import {curveLinear} from '@visx/curve';
import {GlyphDot} from '@visx/glyph';
import {AnimatedLineSeries, AnimatedGlyphSeries} from '@visx/xychart';
import {memo} from 'react';

import type {LineDatum} from '../utils/types';

type Props<T extends LineDatum> = {
  data: T;
  getX: (d: T['items'][number]) => number;
  getY: (d: T['items'][number]) => number;
};
export const LineChartLine = memo(function LineChartLine<T extends LineDatum>({
  data,
  getX,
  getY,
}: Props<T>): React.JSX.Element {
  return (
    <>
      <AnimatedLineSeries
        dataKey={`line-${data.id ?? 'static'}`}
        data={data.items}
        xAccessor={getX}
        yAccessor={getY}
        curve={curveLinear}
        stroke={data.fill}
        enableEvents={false}
      />

      <AnimatedGlyphSeries
        dataKey={data.id ?? 'static'}
        data={data.items}
        xAccessor={getX}
        yAccessor={getY}
        colorAccessor={() => data.fill}
        renderGlyph={({color, x, y, size}) => (
          <GlyphDot
            left={x}
            top={y}
            fill={color}
            r={size / 2}
            // {...handlers}
          />
        )}
      />
    </>
  );
});
